module.exports = __webpack_public_path__ + "img/individual_phone-06.ed070115.svg";